import { REMOVE_STALE_USERS } from 'root/src/shared/descriptions/endpoints/endpointIds'

import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema'

export default {
	[REMOVE_STALE_USERS]: {
		payloadSchema: cronJobPayloadSchema,
		isCron: true,
	},
}
